<template>
  <sui-modal v-model="visible" :closable="false">
    <sui-modal-header>
      Logs
    </sui-modal-header>
    <sui-modal-content>
      <sui-form style="margin-bottom: 1em" v-if="!weaveId">
        <sui-form-fields>
          <sui-form-field :width="4">
            <label>Host</label>
            <sui-dropdown selection search v-model="hostId" :options="hostsList" direction="downward" placeholder="Select host..." />
          </sui-form-field>
          <sui-form-field :width="4">
            <label>Service</label>
            <sui-dropdown selection search v-model="serviceId" :options="servicesList" direction="downward" placeholder="Select service..." />
          </sui-form-field>
          <sui-form-field :width="4">
            <label>{{containersTitle}}</label>
            <sui-dropdown selection search v-model="containerId" :options="containersList" direction="downward" placeholder="Select container..." />
          </sui-form-field>
          <sui-form-field :width="4">
            <label>Task</label>
            <sui-dropdown selection search v-model="taskId" :options="tasksList" direction="downward" placeholder="Select task..." />
          </sui-form-field>
        </sui-form-fields>
      </sui-form>
      <div>
        <EntityLog :entity="selectedEntity" :height="height" v-if="selectedEntity" />
        <TaskLog :taskId="taskId" :height="height" v-if="taskId" />
        <WeaveLog :hostId="weaveId" :height="height" v-if="weaveId" />
      </div>
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button-group>
        <sui-button icon="times" label-position="left" color="red" @click="close()">Close</sui-button>
      </sui-button-group>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import EntityLog from '@/components/EntityLog'
  import TaskLog from '@/components/TaskLog'
  import WeaveLog from '@/components/WeaveLog'
  import utils from '@/utils'

  export default {
    name: 'ModalLog',
    components: {
      EntityLog,
      TaskLog,
      WeaveLog,
    },
    data() {
      return {
        visible: false,
        height: 500,
        weaveId: null,
        hostId: null,
        serviceId: null,
        containerId: null,
        taskId: null,
      }
    },
    computed: {
      ...mapGetters(['hosts', 'hostsById', 'services', 'servicesById', 'containers', 'containersById']),
      selectedEntity() {
        return this.hostsById[this.hostId] || this.servicesById[this.serviceId] || this.containersById[this.containerId] || null
      },
      hostsList() {
        const hostsList = this.hosts.map(host => {
          const hostLogo = host && host._logo
          return {
            image: hostLogo ? {src: hostLogo} : null,
            text: host.name,
            value: host.id,
          }
        })
        if (this.hostId) {
          hostsList.unshift({
            text: 'Remove selection',
            value: null,
          })
        }
        return hostsList
      },
      servicesList() {
        const servicesList = this.services.map(service => {
          const serviceLogo = service && service._logo
          return {
            image: serviceLogo ? {src: serviceLogo} : null,
            text: service.name,
            value: service.id,
          }
        })
        if (this.serviceId) {
          servicesList.unshift({
            text: 'Remove selection',
            value: null,
          })
        }
        return servicesList
      },
      containersList() {
        const selectedEntity = this.hostsById[this.hostId] || this.servicesById[this.serviceId]
        const containers = selectedEntity ? selectedEntity._containers : this.containers
        const containersList = containers.filter(container => container._host || container._service).map(container => {
          const host = container._host
          const service = container._service
          const containerLogo = (this.serviceId && host) ? (host && host._logo) : (service && service._logo)
          return {
            image: containerLogo ? {src: containerLogo} : null,
            text: container.name,
            value: container.id,
          }
        })
        if (this.containerid) {
          containersList.unshift({
            text: 'Remove selection',
            value: null,
          })
        }
        return containersList
      },
      tasksList() {
        return this.services.reduce((tasks, service) => {
          return tasks.concat(service.crons.map(task => {
            const serviceLogo = service && service._logo
            return {
              image: serviceLogo ? {src: serviceLogo} : null,
              text: task.name,
              value: task.id,
            }
          }))
        }, [])
      },
      containersTitle() {
        return this.hostId ? 'Host containers' : (this.serviceId ? 'Service container' : 'Container')
      },
    },
    watch: {
      visible(visible) {
        if (visible) {
          this.height = window.innerHeight - 350
        } else {
          setTimeout(() => {
            this.reset()
          }, 500)
        }
      },
      hostId(id1, id2) {
        utils.reachGoal('LOGS_MANAGER_SELECT_HOST')
        if (!id2) {
          this.serviceId = null
          this.containerId = null
          this.taskId = null
        }
      },
      serviceId(id1, id2) {
        utils.reachGoal('LOGS_MANAGER_SELECT_SERVICE')
        if (!id2) {
          this.hostId = null
          this.containerId = null
          this.taskId = null
        }
      },
      containerId(id1, id2) {
        utils.reachGoal('LOGS_MANAGER_SELECT_CONTAINER')
        if (!id2) {
          this.hostId = null
          this.serviceId = null
          this.taskId = null
        }
      },
      taskId(id1, id2) {
        utils.reachGoal('LOGS_MANAGER_SELECT_TASK')
        if (!id2) {
          this.hostId = null
          this.serviceId = null
          this.containerId = null
        }
      },
    },
    methods: {
      open(entity = null) {
        this.visible = true
        this.height = window.innerHeight - 350
        if (entity) {
          this[`${entity.target}Id`] = entity.id
        }
      },
      close() {
        this.visible = false
      },
      reset() {
        this.hostId = null
        this.serviceId = null
        this.containerId = null
        this.taskId = null
        this.weaveId = null
      },
    },
    created() {
      this.$modals.log = this
    },
  }
</script>
